import { identity, memoizeWith } from 'ramda';

const mem = memoizeWith(identity);

export const assetsSelector = mem((module) => (state) => state.admin.files.data.filter((d) => d.type === module));
export const metaSelector = mem((module) => (state) => state.admin.files.meta.filter((d) => d.type === module));
export const isModalLoaderSelector = (state) => state.admin.files.isModalLoader;
export const isGlobalLoaderSelector = (state) => state.admin.files.isGlobalLoader;
export const nextPageSelector = (state) => state.admin.files.nextPage;
export const searchSelector = (state) => state.admin.files.search;
export const ownershipSelector = (state) => state.admin.files.ownership;
